import consts from "@/consts"
import {getApiProps} from "@/lib/lib";
import range from "lodash/range";
// import {objectComparison} from "@/lib/lib";
const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        usersProfilesLiteLoad: false,
        usersProfilesFullLoad: false,
        usersProfiles: [],
    },
    actions: {
        fetchUsersProfiles/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchUsersProfiles', args, time: Date.now() / 1000})

                const params = getApiProps('usersProfiles', args)
                this.$api.usersProfiles.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUsersProfiles', args, inprogress: false})
                    });
            })
        },
        fetchUsersProfilesAll({dispatch, commit}) {
            new Promise((resolve, reject) => {
                this.$api.usersProfiles.getAll()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setUsersProfiles', response.data)
                            commit('setUsersProfilesLiteLoad', true)
                            commit('setUsersProfilesFullLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchUsersProfilesAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchUsersProfilesAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isUsersProfilesLiteLoad) {
                    return resolve(getters.getUsersProfiles.length)
                }
                dispatch('fetchUsersProfiles', {lite: true})
                    .then((data) => {
                        commit('updateUsersProfiles', data)
                        //commit('setUsersProfilesLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchUsersProfilesAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchUsersProfilesAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchUsersProfilesAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchUsersProfilesChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getUsersProfiles.length) {
                        return resolve([])
                    }
                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getUsersProfiles.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchUsersProfiles', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateUsersProfiles', data)
                            })
                            .catch(() => {
                                dispatch('fetchUsersProfiles', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setUsersProfilesFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchUsersProfilesAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchUsersProfilesChanged', args, inprogress: false})
                })
        },
        fetchUsersProfilesChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isUsersProfilesFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchUsersProfilesChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchUsersProfiles', args)
                .then((data) => {
                    commit('updateUsersProfiles', data)
                    return dispatch('fetchUsersProfiles', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterUsersProfiles', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchUsersProfilesChanged', args, inprogress: false})
                });
        },
        fetchFavoritesUsersProfiles({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchFavoritesUsersProfiles', args, time: Date.now() / 1000})

                dispatch('fetchUsersProfiles', {filter: {favorites: true}})
                    .then((data) => {
                        commit('updateUsersProfiles', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesUsersProfiles', args, inprogress: false})
                    });
            })
        },
        reloadUsersProfilesAll({commit, dispatch}, args) {
            commit('clearUsersProfiles')
            return dispatch('fetchUsersProfilesAllLite', args)
                .then(() => {
                    dispatch('fetchUsersProfilesAllPages', args)
                })
        },

        fetchUserProfile({commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }
                const params = getApiProps('usersProfiles', args)
                delete params.id;
                this.$api.usersProfiles.find(args.id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateUserProfile', response.data)
                            resolve(true)
                        } else {
                            console.error(response);
                            reject(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(false)
                    });
            });
        },

        saveUserProfile({dispatch}, usersProfile) {
            let fn = (usersProfile.id) ? 'updateUserProfile' : 'createUserProfile'
            return dispatch(fn, usersProfile);
        },
        createUserProfile({commit, dispatch}, usersProfile) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('usersProfiles')
                this.$api.usersProfiles.create(usersProfile, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateUserProfile', response.data)
                            dispatch('fetchUsersProfilesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateUserProfile({commit, dispatch}, usersProfile) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('usersProfiles')
                this.$api.usersProfiles.update(usersProfile.id, usersProfile, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateUserProfile', response.data)
                            dispatch('fetchUsersProfilesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        deleteUserProfile({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('usersProfiles')
                this.$api.usersProfiles.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteUserProfile', id)
                            else commit('updateUserProfile', response.data)
                            dispatch('fetchUsersProfilesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        restoreUserProfile({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('usersProfiles')
                this.$api.usersProfiles.restore(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateUserProfile', response.data)
                            dispatch('fetchUsersProfilesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteUserProfilePermanently({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('usersProfiles')
                this.$api.usersProfiles.deletePermanently(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteUserProfile', id)
                            dispatch('fetchUsersProfilesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        //sayHello() {}
    },
    mutations: {
        setUsersProfilesLiteLoad(state, LiteLoad) {
            state.usersProfilesLiteLoad = state.usersProfilesLiteLoad || LiteLoad
        },
        setUsersProfilesFullLoad(state, FullLoad) {
            state.usersProfilesFullLoad = state.usersProfilesFullLoad || FullLoad
        },

        setUsersProfiles(state, nUsersProfiles) {
            nUsersProfiles = nUsersProfiles.map(u => {
                //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return Object.freeze(u)
            })
            nUsersProfiles.sort(sortByName)
            state.usersProfiles = nUsersProfiles
        },

        updateUsersProfiles(state, nUsersProfiles) {
            if (!state.usersProfiles.length) {
                nUsersProfiles = nUsersProfiles.map(u => {
                    //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return Object.freeze(u)
                })
                nUsersProfiles.sort(sortByName)
                state.usersProfiles = nUsersProfiles
                return true
            }

            // console.log('updateUsersProfiles', state.usersProfiles.length)
            nUsersProfiles.forEach(function (nUsersProfile) {
                let i = state.usersProfiles.findIndex(u => (u.id == nUsersProfile.id))
                if (i < 0) {
                    state.usersProfiles.push(Object.freeze(nUsersProfile))
                } else
                if (!state.usersProfilesFullLoad || state.usersProfiles[i][changedField] != nUsersProfile[changedField]) {
                    // updateObjectByDiff(state.usersProfiles[i], nUsersProfile)
                    delete nUsersProfile.id
                    state.usersProfiles[i] = Object.freeze({...state.usersProfiles[i], ...nUsersProfile})
                }
            })
        },
        filterUsersProfiles(state, nUsersProfiles) {
            // let Ids = state.usersProfiles.map(u=> u.id)
            let nIds = nUsersProfiles.map(u => u.id)
            let removedIds = state.usersProfiles.filter(u => !nIds.includes(u.id)).map(u => u.id)
            removedIds.forEach(removedId => {
                let i = state.usersProfiles.findIndex(u => (u.id == removedId))
                if (i != -1) {
                    state.usersProfiles.splice(i, 1)
                }
            })
        },
        updateUserProfile(state, nUsersProfile) {
            let i = state.usersProfiles.findIndex(u => (u.id == nUsersProfile.id))
            if (i < 0) {
                state.usersProfiles.push(Object.freeze(nUsersProfile))
            } else
            if (!state.usersProfilesFullLoad || state.usersProfiles[i][changedField] != nUsersProfile[changedField]) {
                // updateObjectByDiff(state.usersProfiles[i], nUsersProfile)
                let usersProfile = {...nUsersProfile} //ToDo fix
                delete usersProfile.id
                state.usersProfiles[i] = Object.freeze({...state.usersProfiles[i], ...usersProfile})
            }
        },
        deleteUserProfile(state, id) {
            let i = state.usersProfiles.findIndex(u => (u.id == id))
            if (i != -1) {
                state.usersProfiles.splice(i, 1)
            }
        },
        clearUsersProfiles(state) {
            state.usersProfiles = []
            state.usersProfilesLiteLoad = false
            state.usersProfilesFullLoad = false
        },
    },
    getters: {
        isUsersProfilesLiteLoad(state) {
            return state.usersProfilesLiteLoad
        },
        isUsersProfilesFullLoad(state) {
            return state.usersProfilesFullLoad
        },
        getUsersProfiles(state) {
            return state.usersProfiles
        },
        getUsersProfilesByIds(state) {
            return state.usersProfiles.reduce((usersProfilesByIds, u) => {
                usersProfilesByIds[u.id] = u
                return usersProfilesByIds
            }, {})
        },
    }
}
